export const generatePropertyTitle = (
  formData,
  attributeValues,
  config = {}
) => {
  const getLabel = (id) => {
    const item = attributeValues.find(
      (v) => String(v.id) === String(id)
    );

    return item?.label || id;
  };

  const formatName = (name) =>
    name
      ? String(name)
          .trim()
          .replace(/\b\w/g, (c) => c.toUpperCase())
      : "";

  const {
    bhkKey = "bhkType",
    typeKey = "apartmentType",
    defaultTitle = "Property",
    postedFor = "",
  } = config;

  const bhk = getLabel(formData?.[bhkKey]);
  const type = getLabel(formData?.[typeKey]);

const city =
  formData?.villageName ||
  formData?.village_name ||
  formData?.location?.villageName ||
  formData?.location?.village_name ||
  formData?.village ||
  "";
  const titleParts = [];

  if (bhk) {
    titleParts.push(bhk);
  }

  if (type) {
    titleParts.push(type);
  }

  if (postedFor) {
    titleParts.push(`for ${postedFor}`);
  }

  if (city) {
    titleParts.push(`in ${formatName(city)}`);
  }

  return titleParts.join(" ") || defaultTitle;
};


export const generateFlatmatesTitle = (formData, attributeValues) => {
  const getLabel = (id) => {
    const item = attributeValues.find(v => String(v.id) === String(id));
    return item?.label || id;
  };

  const formatName = (name) =>
    name?.replace(/\b\w/g, (c) => c.toUpperCase());

  const roomType =
    formData?.roomType === "single"
      ? "Single Room"
      : formData?.roomType === "shared"
      ? "Shared Room"
      : "";

  const tenantType =
    formData?.tenantType
      ? formatName(formData.tenantType) 
      : "";

  const bhk = getLabel(formData?.bhkType);

  const location =
    formData?.villageName ||
    "Kanyakumari"; 

  const titleParts = [];

  if (roomType) titleParts.push(roomType);
  if (tenantType) titleParts.push(`for ${tenantType}`);
  if (bhk) titleParts.push(`in ${bhk}`);
  if (location) titleParts.push(`in ${formatName(location)}`);

  return titleParts.join(" ") || "Flatmates Property";
};




export const generatePGTitle = (formData) => {
  const formatName = (name) =>
    name?.replace(/\b\w/g, (c) => c.toUpperCase());

  const tenant =
    formData?.pgPlaceAvailableFor
      ? formatName(formData.pgPlaceAvailableFor)
      : "Anyone";

  const location =
    formData?.villageName || "Kanyakumari";

  return `PG for ${tenant} in ${formatName(location)}`;
};


export const generatePlotTitle = (formData, config = {}) => {
  const formatName = (name) =>
    name?.replace(/\b\w/g, (c) => c.toUpperCase());

  const {
    postedFor = "Sale",
  } = config;

  const location = formData?.villageName || "Kanyakumari";
  const formattedLocation = formatName(location);

  // Fix: Add "Plot for" prefix
  return `Plot for ${postedFor} in ${formattedLocation}`;
};